module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"audit_score":"Audit Score - Erfüllungsgrad des Audits"},"en":{"audit_score":"Audit Score - Erfüllungsgrad des Audits"}}')
  delete Component.options._Ctor
}
